import React, { Component } from 'react'
import { connect } from 'react-redux'

function mapStateToProps(state) {
    return {
        open: state.getIn(['ui', 'ribbon', 'open']),
    }
}

export default function (InnerComponent) {
    @connect(mapStateToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
